function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { brandListApi, productDetailApi } from '@/api/product';
import { mapGetters } from 'vuex';
import { pointsProductDetailApi } from '@/api/pointsMall';
import { objTitlePoints, defaultObj, defaultObjAttrValue, objTitle } from '@/views/marketing/pointsMall/default';
var defaultProductImage = require('@/assets/imgs/no.png');
export default {
  data: function data() {
    return {
      // manyTabTit: {},
      // manyTabDate: {},
      formValidate: Object.assign({}, defaultObj),
      labelarr: [],
      ruleList: [],
      merCateList: [],
      // 店铺分类筛选
      shippingList: [],
      // 运费模板

      // OneattrValue: [Object.assign({}, defaultObj.attrValue[0])], // 单规格
      // ManyAttrValue: [Object.assign({}, defaultObj.attrValue[0])], // 多规格
      brandList: [],
      search: {
        limit: 9999,
        page: 1,
        cid: '',
        brandName: ''
      },
      loading: false,
      attrInfo: {},
      tempRoute: {},
      videoLink: '',
      fullscreenLoading: false,
      //积分商品
      dialogVisibleInfo: false,
      // 控制积分、商品详情抽屉展示
      AttrValueList: [] //详情中使用规格列表
      // componentKey: 0,
      // isShow: false, //控制商品详情展示
      // productId: 0, //商品id，普通、活动商品都是此id
    };
  },
  computed: _objectSpread({}, mapGetters(['merPlatProductClassify', 'productBrand'])),
  methods: {
    // 点击商品图
    modalPicTap: function modalPicTap(multiple, num, i, status) {
      var _this = this;
      if (_this.isDisabled) return;
      this.$modalUpload(function (img) {
        if (!img) return;
        if (!multiple && !num) {
          _this.formValidate.image = img[0].sattDir;
          _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (multiple && !num) {
          if (img.length > 10) return this.$message.warning('最多选择10张图片！');
          if (img.length + _this.formValidate.sliderImages.length > 10) return this.$message.warning('最多选择10张图片！');
          img.map(function (item) {
            _this.formValidate.sliderImages.push(item.sattDir);
          });
        }
        if (!multiple && num === 'dan') {
          _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (!multiple && num === 'duo') {
          _this.ManyAttrValue[i].image = img[0].sattDir;
        }
        if (!multiple && num === 'pi') {
          _this.oneFormBatch[0].image = img[0].sattDir;
        }
      }, multiple, 'content');
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      if (!this.isDisabled) this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      if (!this.isDisabled) this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      if (!this.isDisabled) e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item, index) {
      if (!this.isDisabled) {
        e.dataTransfer.effectAllowed = 'move';
        if (item === this.dragging) {
          return;
        }
        var newItems = index || index === 0 ? _toConsumableArray(this.formValidate.attrList[index].optionList) : _toConsumableArray(this.formValidate.sliderImages);
        var src = newItems.indexOf(this.dragging);
        var dst = newItems.indexOf(item);
        newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
        if (index || index === 0) {
          this.formValidate.attrList[index].optionList = newItems;
        } else {
          this.formValidate.sliderImages = newItems;
        }
      }
    },
    // 解决cascader placeholder重影
    fixCascader: function fixCascader() {
      var cascader = document.querySelectorAll('.el-cascader__search-input');
      for (var index = 0; index < cascader.length; index++) {
        cascader[index].setAttribute('placeholder', '');
      }
    },
    //普通商品详情
    getProductInfo: function getProductInfo(id, type) {
      var _this2 = this;
      this.formThead = Object.assign({}, objTitle);
      this.fullscreenLoading = true;
      this.getbrandList();
      productDetailApi(id).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _this2.isShowAttr = true;
                _this2.getData(res, type);
                _this2.fullscreenLoading = false;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this2.fullscreenLoading = false;
      });
    },
    // 积分商品详情
    getPointsProductInfo: function getPointsProductInfo(id, type) {
      var _this3 = this;
      this.formThead = Object.assign({}, objTitlePoints);
      // this.getPointsProductAttrValue();
      this.fullscreenLoading = true;
      pointsProductDetailApi(id).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _this3.isShowAttr = true;
                _this3.getData(res, type);
                _this3.fullscreenLoading = false;
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this3.fullscreenLoading = false;
      });
    },
    // 获取积分商品规格数据
    getPointsProductAttrValue: function getPointsProductAttrValue() {
      var obj = Object.assign({}, defaultObjAttrValue);
      delete obj.image;
      this.tableAttrValue = obj;
    },
    // 商品详情数据
    getData: function getData(res, type) {
      var _this4 = this;
      this.AttrValueList = [];
      var info = res;
      var sliderImages = this.normalizeImageList(info.sliderImage, info.image);
      var attrValueList = Array.isArray(info.attrValueList) ? info.attrValueList : [];
      var attrList = Array.isArray(info.attrList) ? info.attrList : [];
      this.formValidate = _objectSpread(_objectSpread({}, info), {}, {
        image: this.normalizeImage(info.image),
        sliderImages: sliderImages,
        cateIds: info.cateId ? info.cateId.split(',').map(Number) : '',
        // 商品分类id
        couponList: info.couponList || [],
        //优惠券
        sort: info.sort ? info.sort : 0,
        attrList: attrList,
        attrValueList: attrValueList,
        content: info.content ? this.$selfUtil.replaceImgSrcHttps(info.content) : '',
        id: info.id ? info.id : 0,
        exchangeNum: info.exchangeNum || 0,
        isHot: info.isHot
      });

      //详情中使用，规格数据生成规格的格式
      this.AttrValueList = _toConsumableArray(attrValueList);
      this.AttrValueList = this.AttrValueList.map(function (item) {
        return _objectSpread(_objectSpread({}, item), _this4.parseJsonObject(item.attrValue));
      });
      this.getTableHeader();
      /*******/

      this.labelarr = info.keyword ? info.keyword.split(',') : [];
      this.formValidate.sliderImages = _toConsumableArray(sliderImages);
      if (this.getFileType(this.formValidate.sliderImages[0]) == 'video') {
        //如果返回数据轮播图的第一张是视频，就将其赋值给videoLink做渲染，同时将其在轮播图中删除
        this.$set(this, 'videoLink', this.formValidate.sliderImages[0]);
        this.formValidate.sliderImages.splice(0, 1);
      }
      if (info.specType) {
        //this.productGetRule(); //加载商品规格选项
        if (attrValueList.length) {
          attrValueList.forEach(function (val) {
            val.image = _this4.normalizeImage(val.image);
            val.attrValueShow = _this4.parseJsonObject(val.attrValue);
            val.attr_arr = val.sku ? val.sku.split(',') : [];
            val.brokerage = val.brokerage || 0;
            val.brokerageTwo = val.brokerageTwo || 0;
            val.isShow = true;
            if (type === 'normal') val.cost = val.otPrice;
          });
          this.ManyAttrValue = [].concat(_toConsumableArray(this.oneFormBatch), _toConsumableArray(attrValueList));
          this.getTableHeader();
        } else {
          if (this.formValidate.attrList.length) {
            this.oneFormBatch[0].image = this.normalizeImage(info.image);
          }
        }
      } else {
        attrValueList.forEach(function (val) {
          if (type === 'normal') val.cost = val.otPrice;
        });
        this.OneattrValue = attrValueList;
      }
    },
    parseJsonObject: function parseJsonObject(value) {
      if (!value) return {};
      if (_typeof(value) === 'object') return value;
      try {
        var parsed = JSON.parse(value);
        return parsed && _typeof(parsed) === 'object' && !Array.isArray(parsed) ? parsed : {};
      } catch (e) {
        return {};
      }
    },
    parseJsonArray: function parseJsonArray(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value;
      try {
        var parsed = JSON.parse(value);
        if (Array.isArray(parsed)) return parsed;
        if (parsed && _typeof(parsed) === 'object') {
          return Object.keys(parsed).map(function (key) {
            return parsed[key];
          }).filter(Boolean);
        }
      } catch (e) {
        if (typeof value === 'string') return value.split(',').map(function (item) {
          return item.trim();
        }).filter(Boolean);
      }
      return [];
    },
    normalizeImageList: function normalizeImageList(sliderImage, image) {
      var _this5 = this;
      var images = this.parseJsonArray(sliderImage);
      if (!images.length && image) images = [image];
      if (!images.length) images = [defaultProductImage];
      return images.filter(Boolean).map(function (item) {
        return _this5.normalizeImage(item);
      });
    },
    normalizeImage: function normalizeImage(image) {
      if (!image) return defaultProductImage;
      return this.$selfUtil.setDomain(image);
    },
    getTableHeader: function getTableHeader() {
      var tmp = {};
      var tmpTab = {};
      this.formValidate.attrList.forEach(function (o, i) {
        tmp[o.attributeName] = {
          title: o.attributeName
        };
        tmpTab[o.attributeName] = '';
      });
      this.manyTabTit = tmp;
      this.manyTabDate = tmpTab;
    },
    getFileType: function getFileType(fileName) {
      // 后缀获取
      var suffix = '';
      // 获取类型结果
      var result = '';
      try {
        var flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return false;
      }
      suffix = suffix.toLocaleLowerCase();
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      // 进行图片匹配
      result = imglist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'image';
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videolist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'video';
      }
      // 其他 文件类型
      return 'other';
    },
    // 品牌列表
    getbrandList: function getbrandList() {
      var _this6 = this;
      this.search.cid = this.formValidate.categoryId;
      brandListApi(this.search).then(function (res) {
        _this6.brandList = res.list;
        _this6.brandList.unshift({
          id: 0,
          name: '其他',
          isShow: true
        });
      });
    },
    //详情关闭
    onCloseInfo: function onCloseInfo() {
      this.dialogVisibleInfo = false;
    }
  }
};